// extracted by mini-css-extract-plugin
module.exports = {"starRating":"StarRating_starRating__MMp_R","star":"StarRating_star__rfr3L","starActive":"StarRating_starActive__pu29_"};